"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function BackupGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "orion-icon-backup-grey-outline-a",
    width: 17,
    height: 13,
    x: -0.8,
    y: 0,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-0.8 0H16.2V13H-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.386 11.883h9.25a3.13 3.13 0 001.17-6.044v-.058a4.796 4.796 0 00-8.224-3.339 3.14 3.14 0 00-3.934 3.704 3.11 3.11 0 001.738 5.737zM2.329 5.45a2.36 2.36 0 012.363-2.352V3.09c.295.005.587.066.86.18a.389.389 0 00.43-.11 4.019 4.019 0 017.04 2.636v.303a.389.389 0 00.28.389 2.352 2.352 0 01-.645 4.617h-9.27a2.332 2.332 0 01-1.12-4.435.389.389 0 00.186-.47 2.332 2.332 0 01-.124-.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.386 11.883h9.25a3.13 3.13 0 001.17-6.044v-.058a4.796 4.796 0 00-8.224-3.339 3.14 3.14 0 00-3.934 3.704 3.11 3.11 0 001.738 5.737zM2.329 5.45a2.36 2.36 0 012.363-2.352V3.09c.295.005.587.066.86.18a.389.389 0 00.43-.11 4.019 4.019 0 017.04 2.636v.303a.389.389 0 00.28.389 2.352 2.352 0 01-.645 4.617h-9.27a2.332 2.332 0 01-1.12-4.435.389.389 0 00.186-.47 2.332 2.332 0 01-.124-.75z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.637 11.883l.002-.2h-.002v.2zm-9.251 0v-.2H3.38l.005.2zM15.742 9.35l-.196-.038.196.038zm-1.935-3.51h-.2v.137l.127.05.073-.187zm0-.058h.2-.2zm-2.993-4.429l.076-.185-.076.185zm-5.232 1.09l-.055.192.114.033.084-.085-.143-.14zm-2.755.505l.12.16-.12-.16zM1.571 5.451l-.2-.001h.2zm.077.695l.107.17.12-.076-.032-.138-.195.044zM.334 9.676l.191-.058-.191.058zm4.358-6.578v.2h.2v-.2h-.2zM2.33 5.45h-.2.2zm2.363-2.36l.003-.2-.203-.003v.203h.2zm.86.18l-.078.184.006.002.071-.187zm.43-.11l-.15-.132v.001l.15.131zm4.43-1.112l.07-.187-.07.187zm2.61 3.748h.2v-.001h-.2zm0 .303l.2.008v-.008h-.2zm.28.389l-.056.192h.002l.054-.192zm1.7 2.591l.199.028-.198-.028zm-2.345 2.026l.001-.2h-.001v.2zm-9.27 0v-.2h-.01l.01.2zM1.007 9.347l-.194.049.194-.05zM2.267 6.67l.086.18.007-.003-.093-.177zm.186-.47l-.189.064.19-.064zm10.184 5.483H3.386v.4h9.25v-.4zm2.909-2.372a2.929 2.929 0 01-2.907 2.372l-.004.4a3.329 3.329 0 003.304-2.696l-.393-.076zm-1.812-3.285a2.929 2.929 0 011.812 3.285l.393.076a3.329 3.329 0 00-2.06-3.734l-.145.373zm-.127-.245v.058h.4v-.058h-.4zm-2.868-4.243a4.596 4.596 0 012.868 4.244l.4-.002a4.996 4.996 0 00-3.117-4.613l-.15.37zM5.725 2.582a4.596 4.596 0 015.014-1.044l.15-.37a4.997 4.997 0 00-5.45 1.134l.286.28zm-2.778.525a2.94 2.94 0 012.58-.473l.11-.384a3.34 3.34 0 00-2.93.537l.24.32zM1.771 5.451a2.94 2.94 0 011.176-2.344l-.24-.32A3.34 3.34 0 001.371 5.45l.4.001zm.072.65a2.91 2.91 0 01-.072-.65h-.4c0 .248.027.497.082.74l.39-.09zM.525 9.619a2.91 2.91 0 011.23-3.303l-.213-.338a3.31 3.31 0 00-1.4 3.757l.383-.116zm2.856 2.065A2.91 2.91 0 01.525 9.618l-.383.116a3.31 3.31 0 003.249 2.35l-.01-.4zm1.312-8.785A2.56 2.56 0 002.129 5.45l.4.001a2.16 2.16 0 012.163-2.152v-.4zm-.2.192v.008h.4V3.09h-.4zm1.135-.005a2.532 2.532 0 00-.933-.195l-.006.4c.27.005.536.06.785.164l.154-.37zm.204-.056a.189.189 0 01-.21.053l-.142.374c.231.088.492.022.654-.165l-.302-.262zm4.65-1.168a4.22 4.22 0 00-4.65 1.167l.301.264a3.819 3.819 0 014.209-1.057l.14-.374zm2.74 3.934a4.219 4.219 0 00-2.74-3.934l-.14.374a3.819 3.819 0 012.48 3.561l.4-.001zm0 .304v-.303h-.4v.303h.4zm.136.196a.189.189 0 01-.136-.188l-.4-.016c-.01.27.164.513.424.589l.112-.385zM15.2 9.107a2.552 2.552 0 00-1.846-2.812l-.107.385a2.152 2.152 0 011.557 2.371l.396.056zm-2.546 2.198c1.28.01 2.369-.93 2.546-2.198l-.396-.056a2.152 2.152 0 01-2.147 1.854l-.003.4zm-9.269 0h9.27v-.4h-9.27v.4zM.814 9.395a2.532 2.532 0 002.582 1.91l-.02-.4a2.132 2.132 0 01-2.174-1.607l-.388.098zM2.181 6.49A2.532 2.532 0 00.814 9.396l.388-.098a2.132 2.132 0 011.15-2.447l-.171-.361zm.083-.225a.189.189 0 01-.09.228l.186.354a.589.589 0 00.283-.712l-.379.13zM2.13 5.45c0 .277.046.552.135.814l.379-.129a2.132 2.132 0 01-.114-.685h-.4z",
    mask: "url(#orion-icon-backup-grey-outline-a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    stroke: "#6C757D",
    strokeWidth: 0.2,
    d: "M7.684 14.555a.498.498 0 10.997 0V5.797a.498.498 0 10-.997 0v8.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    stroke: "#6C757D",
    strokeWidth: 0.2,
    d: "M10.397 8.278a.5.5 0 00.354-.854L8.53 5.205a.5.5 0 00-.706 0l-2.22 2.22a.5.5 0 00.354.853h4.438z"
  }));
}

BackupGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
BackupGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = BackupGreyOutline;
exports["default"] = _default;